"use client";

import { useTranslate } from "../../lib/translation";
import styles from "./Link.module.css";

/**
 * Screen-reader text naming an off-site link. A client leaf so Link itself can
 * still render in Server Components; the icon it accompanies is decorative.
 */
export default function ExternalLinkLabel() {
  const t = useTranslate();
  return <span className={styles.srOnly}>{` (${t("linkExternal")})`}</span>;
}
